<!--
 * @Author: your name
 * @Date: 2020-08-11 14:27:03
 * @LastEditTime: 2020-08-12 10:12:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-web\src\components\insureSuccess\insureSuccess.vue
-->
<template>
  <div class="insureSuccess-wrap"
  v-loading="loading"
    element-loading-text="正在查询您的投保信息，请稍等~"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="insureSuccess-back">
      <div class="insureSuccess-text">
        <div style="text-align: center;margin-bottom:0.1rem;font-weight: bolder;">投保成功确认函</div>
        <div class="insureSuccess-text-box">
          <div>尊敬的<span class="border-box">{{recognizeeInfo.owner_name}}</span>（被保险人）：</div>
          <div style="line-height: 0.2rem;"><span class="margin-left-span"></span> 您已成功在中华联合承保漏水险，保费：<span class="border-box">{{recognizeeInfo.payment_money}}</span>元。保险期限：<span class="border-box">{{ insurancePeriod[0] }}</span>至<span class="border-box">{{ insurancePeriod[1] }}</span>。</div>
          <div>
            <div style="font-weight: bolder;opacity:1;color:#000">一、投保漏水险后，保险公司承担以下<span class="color-box">保险责任</span>：</div>
            <div>
              <div><span class="margin-left-span"></span>1、保障取暖用户因其所居住的<span class="color-box" style="font-weight: bolder;">房屋内的暖气管道（含暖气片）突然破裂致使水流外溢，</span><span style="opacity:1;color:#000;font-weight: bolder;font-weight:bolder" >造成用户房屋或邻居房屋内</span><span class="color-box" style="font-weight: bolder;">财产的直接损失</span>；</div>
              <div><span class="margin-left-span"></span>2、本保险适用保险条款名称为《家庭财产综合保险条款（2009版）》及所投保的相应附加险保险条款；</div>
              <div><span class="margin-left-span"></span>3、本产品保险合同中《附加管道破裂及水渍保险条款》及《附加第三者责任保险条款》仅承保被保险人在本合同列明的<span class="color-box">住房内部暖气管道（含暖气片）</span>突然破裂致使水流外溢，造成被保险人或<span class="color-box">第三方房屋内财产的直接损失</span>，其他事故造成被保险人或第三方财产损失，保险人不承担保险责任；</div>
              <div><span class="margin-left-span"></span>4、本产品《附加管道破裂及水渍保险条款》中因被保险人在本合同列明的<span class="color-box">住房内部暖气管道（含暖气片）</span>突然破裂致使水流外溢，造成被保险人房屋内财产直接损失保险金额9000元，其中<span class="color-box">室内装潢保险金额5000元，室内财产保险金额4000元</span>；</div>
              <div><span class="margin-left-span"></span>5、本产品《附加第三者责任保险条款》中因被保险人在本合同列明的<span class="color-box">住房内部暖气管道（含暖气片）</span>突然破裂致使水流外溢，造成第三者房屋内财产直接损失保险金额9000元，其中<span class="color-box">室内装潢保险金额5000元，室内财产保险金额4000元</span>；</div>
              <div><span class="margin-left-span"></span>6、每个家庭地址限购<span class="color-box">1</span>份，多出部分无效；</div>
              <div><span class="margin-left-span"></span>7、本产品仅承保建筑结构为钢筋混凝土或砖石混凝土结构的居民住宅，其他结构房屋或用于从事工商业生产、经营活动的财产和出租用作工商业的房屋，保险人不承担保险责任。</div>
            </div>
          </div>
          <div class="significance">
            <div style="font-weight: bolder;"><span class="color-box">二、重要提示：</span></div>
            <div>
              <div><span class="margin-left-span"></span>1、<span class="color-box">投保成功后</span>，您可以通过拨打<span class="color-box">0314-5909020</span>服务专线或到承保公司柜台查询保险单和理赔信息。</div>
              <div><span class="margin-left-span"></span>2、<span class="color-box">出险后</span>，请第一时间拨打全国统一报案电话 <span class="color-box">95585</span> 报案。</div>
            </div>
          </div>
          <div style="text-align: right;margin:0.2rem 0px 0.1rem 0px">中华联合财产保险股份有限公司</div>
          <div>
            <div style="width: 65%;text-align:center;float: right;">承德中心支公司</div>
          </div>                             
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment';
  export default {
    data(){
      return {
        recognizeeInfo:{}, //投保人信息
        insurancePeriod:[],// 保险期限 
        loading:false,
        riskId:'',// 跑路险编号
      }
    },
    methods:{
      // 获取投保人信息
      async getRecognizeeInfo(){
        this.loading = true;
        const res = await this.$http.get(`${this.$url.globalurl}/recognizeeInfo`,{
          data:{
            risk_id:this.riskId
          }
        });
        this.recognizeeInfo = res.result[0];
        const effectiveDate = moment(res.result[0].pay_time).add(2,'days').format('YYYY年MM月DD日');
        const expiryDate = moment(res.result[0].pay_time).add(1,'days').add(1,'years').format('YYYY年MM月DD日');
        this.insurancePeriod.push(effectiveDate,expiryDate);
        this.loading = false;
      }
    },
    mounted(){
      if(this.$route.query){
        this.riskId = this.$route.query.risk_id;
      }
      this.getRecognizeeInfo();
      document.title = '投保成功确认函';
    }
  }
</script>
<style>
  @import url(insureSuccess.scss)
</style>